/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SENSYN ID API
 * - ユーザー、組織情報の取得API
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  DivisionListResponse,
  DivisionResponse,
  PostDivisionInOwnOrganizationBody,
  PutDivisionInOwnOrganizationBody
} from '../model';

import getDivisionsInOwnOrganizationMutator from '../../../mutators/sensyn-id-instance';
import postDivisionInOwnOrganizationMutator from '../../../mutators/sensyn-id-instance';
import putDivisionInOwnOrganizationMutator from '../../../mutators/sensyn-id-instance';



  /**
 * - 自組織の所属一覧を取得する
 * @summary getDivisionsInOwnOrganization
 */
export const getDivisionsInOwnOrganization = (

 ) => {
      return getDivisionsInOwnOrganizationMutator<DivisionListResponse>(
      {url: `/divisions/`, method: 'GET'
    },
      );
    }
  /**
 * - 自組織の所属を追加する
 * @summary getDivisions
 */
export const postDivisionInOwnOrganization = (
    postDivisionInOwnOrganizationBody: PostDivisionInOwnOrganizationBody,
 ) => {
      return postDivisionInOwnOrganizationMutator<DivisionResponse>(
      {url: `/divisions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postDivisionInOwnOrganizationBody
    },
      );
    }
  /**
 * - 自組織の所属を更新する
 * @summary getDivisions
 */
export const putDivisionInOwnOrganization = (
    divisionId: number,
    putDivisionInOwnOrganizationBody: PutDivisionInOwnOrganizationBody,
 ) => {
      return putDivisionInOwnOrganizationMutator<DivisionResponse>(
      {url: `/divisions/${divisionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putDivisionInOwnOrganizationBody
    },
      );
    }
  export type GetDivisionsInOwnOrganizationResult = NonNullable<Awaited<ReturnType<typeof getDivisionsInOwnOrganization>>>
export type PostDivisionInOwnOrganizationResult = NonNullable<Awaited<ReturnType<typeof postDivisionInOwnOrganization>>>
export type PutDivisionInOwnOrganizationResult = NonNullable<Awaited<ReturnType<typeof putDivisionInOwnOrganization>>>
